module.exports = __webpack_public_path__ + "img/add-files.b276e2e6.svg";